<script>
    export let onClick;
    export let label = "Retour";
</script>

<button class="back-btn btn btn-outline btn-content" on:click={onClick}>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    >
        <path d="M19 12H5M12 19l-7-7 7-7" />
    </svg>
    {label}
</button>

<style>
    .back-btn {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        padding: 0.5rem 1rem;
        border-radius: 6px;
        cursor: pointer;
        font-size: 0.95rem;
        transition: all 0.2s;
        width: fit-content;
    }

    .back-btn:hover {
    }
</style>
